import {
  CreateStep1Body,
  CreateStep1Form,
  RolesAssessmentTeamEnum,
  Step1Response,
} from "../../../types/cto/step1";
import {
  CreationTypeEnum,
  SceConditionEnum,
} from "../../../types/cto/ctoTypes";
import { StatusTypes } from "../../../types/statusTypes";
import { MOCK_LONG_TEXT, MOCK_SCE_CODE, MOCK_TAG_CODE } from "../genericMocks";
import {
  mockUser,
  mockUserExternal,
  mockUserExternalConsultant,
  mockUserOpsManager,
  mockUserProcessSafetyLead,
} from "../user";
import { mockCtoCode } from "./ctoMocks.mock";

const invalidUser = {
  user_id: 0,
  role_code: RolesAssessmentTeamEnum.HSE_REPRESENTATIVE,
};
const validUser = {
  user_id: 1,
  role_code: RolesAssessmentTeamEnum.HSE_REPRESENTATIVE,
};
const validUserRoleOthers = {
  user_id: 2,
  role_code: RolesAssessmentTeamEnum.OTHER,
};

export const mockFormValues: CreateStep1Form = {
  assessment_team_plus: [validUserRoleOthers.user_id],
  assessment_team: [invalidUser, validUser],
  sce_condition_code: null,
  sce_condition_comment: null,
  possible_to_manage: null,
  possible_to_manage_comment: null,
  possible_to_manage_files: [],
  safe_to_operate_short_duration: null,
  draft: false,
  justification: null,
  justification_files: undefined,
  initiation_files: [],
};

export const mockStep1Body: CreateStep1Body = {
  assessment_team: [validUser, validUserRoleOthers],
  sce_condition_code: null,
  sce_condition_comment: null,
  possible_to_manage: null,
  possible_to_manage_comment: null,
  possible_to_manage_files: [],
  safe_to_operate_short_duration: null,
  draft: false,
  justification: null,
  justification_files: undefined,
  initiation_files: [],
};

export const dataStep1Body: CreateStep1Body = {
  assessment_team: [
    {
      role_code: RolesAssessmentTeamEnum.RISK_ASSESSMENT_FACILITY,
      user_id: mockUser.user_id,
    },
  ],
  possible_to_manage: false,
  possible_to_manage_comment: MOCK_LONG_TEXT,
  possible_to_manage_files: [],
  safe_to_operate_short_duration: false,
  sce_condition_code: SceConditionEnum.SCE_IMPAIRED,
  sce_condition_comment: null,
  draft: false,
  justification: null,
  justification_files: undefined,
  initiation_files: [],
};

//REFACTOR: Utilizar novos mocks de cto
export const mockCtoStep1Response: Step1Response = {
  cto_summary: "CTO Summary",
  can_user_fill_step: true,
  cto_code: mockCtoCode,
  creation_type: CreationTypeEnum.AUTO,
  tags: [
    {
      tag_code: MOCK_TAG_CODE,
      status: StatusTypes.critical,
      tag_type: "SCE-ONLY",
    },
  ],
  sces: [
    {
      sce_code: MOCK_SCE_CODE,
      status: StatusTypes.critical,
      sce_name: "Active Fire Protection - Firewater, Deluge",
      expected_function: "Func Func",
    },
    {
      sce_code: "PR-01",
      status: StatusTypes.critical,
      sce_name: "Active Fire Protection",
      expected_function: "Func Func",
    },
  ],
  wos: [
    { wo_code: "000004431019", status: StatusTypes.critical },
    {
      wo_code: "000004431016",
      status: StatusTypes.critical,
    },
    {
      status: StatusTypes.critical,
      wo_code: "000004431017",
    },
    {
      status: StatusTypes.critical,
      wo_code: "000004539388",
    },
    {
      status: StatusTypes.critical,
      wo_code: "0000044310172",
    },
    {
      status: StatusTypes.critical,
      wo_code: "000004539588",
    },
    {
      status: StatusTypes.critical,
      wo_code: "000004539585",
    },
  ],
  affected_mahs: [],
  related_ctos: ["CTO-MV00-23-1234"],
  sce_condition_code: SceConditionEnum.OTHER,
  sce_condition_comment: MOCK_LONG_TEXT,
  possible_to_manage: true,
  possible_to_manage_comment: MOCK_LONG_TEXT,
  possible_to_manage_files: [{ attachment_id: 1, file_name: "file.pdf" }],
  safe_to_operate_short_duration: true,
  created_at: new Date("2022-06-02 16:27:27"),
  created_by: mockUser,
  step_approved_at: new Date("2022-06-02 16:27:27"),
  step_approved_by: mockUser,
  draft: false,
  assessment_team: [
    {
      role_code: RolesAssessmentTeamEnum.RISK_ASSESSMENT_FACILITY,
      user: mockUser,
    },
    {
      role_code: RolesAssessmentTeamEnum.HSE_REPRESENTATIVE,
      user: mockUserProcessSafetyLead,
    },
    {
      role_code: RolesAssessmentTeamEnum.RELEVANT_SUPERINTENDENT,
      user: mockUserOpsManager,
    },
    {
      role_code: RolesAssessmentTeamEnum.OPERATION_ENGINEER,
      user: mockUserExternal,
    },
    {
      role_code: RolesAssessmentTeamEnum.OTHER,
      user: mockUserExternalConsultant,
    },
  ],
  justification: null,
  justification_files: undefined,
  initiation_files: [],
};
